import styles from './styles.module.css';
import { Facebook, Twitter, Whatssap } from '@/icons/index';

const SocialLinks = (props) => {

    const {
        url,
        containerClass
    } = props
    return (
        <div className={`${styles['container-social-icons-top']}`}>
            <a href={`https://www.facebook.com/sharer.php?u=https://www.ellitoral.com${url}`} target="_blank" rel='noreferrer noopener'>
                <div className={`${styles["icon"]}`}>
                    <Facebook className={`${styles["internal-icon"]} ${styles["facebook-internal-icon"]} `}/>
                </div>
            </a>
            <a href={`http://twitter.com/share?url=https://www.ellitoral.com${url}`} target="_blank" rel='noreferrer noopener'>
                <div className={`${styles["icon"]}`}>
                    <Twitter className={`${styles["internal-icon"]} ${styles["twitter-internal-icon"]}`}/>
                </div>
            </a>
            <a href={`https://api.whatsapp.com/send?text=Accede%20a%20esta%20noticia%20de%20El%20Litoral:%20https://www.ellitoral.com${url}%3Futm_medium%3Dwhatsapp%20-%20Envianos%20tu%20noticia%20a:%20%2B5493426305344`} target="_blank" rel='noreferrer noopener'>
                <div className={`${styles["icon"]}`}>
                    <Whatssap className={`${styles["internal-icon"]} `}/>
                </div>
            </a>
        </div>
    )
}

export default SocialLinks;